// extracted by mini-css-extract-plugin
export default {"tab":"DiagTypeTabs_tab__Lr2rY"};